/* eslint-disable no-unused-vars */
export const getGridDecorativeIconStyle = ({ components, core: { palette = {} } = {} } = {}) => ({
  centerContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  circleContainer: {
    width: 80,
    height: 41,
    backgroundColor: 'rgb(50,49,48, 0.6)',
    borderRadius: 4,
    boxShadow: '0px 4px 16px rgb(0 0 0 / 14%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconContent: {
    fontSize: 20,
    color: palette.white,
  },
  labelName: {
    fontSize: 16,
    color: palette.white,
    marginLeft: 5,
  },
});
